﻿//
// Blazy
//

var Blazy = require('../lib/blazy.js');

var blazy = function () {
  var bLazy = new Blazy({
    offset: 200,
    success: function (ele) {
      ele.className += " loaded";

      if (ele.tagName === "IMG") {
        ele.parentElement.className += " loaded";
      }
    },
    breakpoints: [{
      width: 420, // max-width
      src: 'data-src-small'
    }, {
      width: 768, // max-width
      src: 'data-src-medium'
    }]
  });
}

var lazyload = document.getElementsByClassName('b-lazy')[0];


if (lazyload) {
  blazy();
}

module.exports = function () {
  blazy();
}
